module.exports = __webpack_public_path__ + "assets/img/00079.b6b5ff19.png";